package kz.dentalcrm.app.screens.patients.add.mvi

import kz.dentalcrm.app.core.base.ViewSideEffect
import kz.dentalcrm.app.data.network.response_model.PatientData

sealed interface AddPatientViewSideEffect : ViewSideEffect {
    data class PatientAdded(val patient: PatientData?) : AddPatientViewSideEffect
}
